import type { IFBDIFormStep } from '../types';

interface IMultiStepHeaderProps {
  steps: IFBDIFormStep[];
  currentStep: number;
}

export default function MultiStepHeader({ steps, currentStep }: IMultiStepHeaderProps) {
  return (
    <div className='flex justify-center items-center py-5 mb-12'>
      <ol className='items-center flex flex-wrap mx-24'>
        {steps.map(({ title }, index) => (
          <li key={title} className='relative my-9 flex text-center sm:mb-0'>
            <div className='flex items-center'>
              <div className='flex justify-center items-center gap-2 relative'>
                <div
                  className={`${
                    currentStep >= index ? 'bg-primaryColor-normal text-white font-bold' : ' bg-gray-200'
                  } z-10 rounded-full ring-0 ring-white shrink-0`}
                >
                  <span className=' flex justify-center items-center w-8 h-8'>{index + 1}</span>
                </div>
                <p className='absolute z-10 top-10 w-48 font-semibold'>{title}</p>
              </div>
              {steps.length - 1 !== index && (
                <div className='mx-5 bg-gray-200 h-1.5 relative w-20 rounded-full overflow-hidden'>
                  <div className='w-full h-full bg-gray-200 absolute '></div>
                  {currentStep === index && (
                    <div className='h-full bg-primaryColor-normal absolute rounded-full' style={{ width: '50%' }}></div>
                  )}
                  {currentStep > index && (
                    <div className='h-full bg-primaryColor-normal absolute rounded-full' style={{ width: '100%' }}></div>
                  )}
                </div>
              )}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
